<template>
  <div>
  <div class="container fluid" v-if="isLoaded && user.authenticated">
    <div class="row">
      <div class="col-md-12">
        <p>
        <strong>Vendor Name:</strong>  {{vendorinfo.name}}<br>
        <strong>Phone Number:</strong>  {{vendorinfo.phoneNumber}}<br>
        <strong>Address:</strong><br>{{vendorinfo.address}}<br>{{vendorinfo.cityStateZip}}
        </p>
      </div>
    </div>
  </div>
  <div class="row" v-else>
    <div class="col text-center">
    <h3>Sorry it looks like you've been logged out, please <router-link to="/login">Login</router-link> to resume</h3>
    </div>
  </div>
  </div>
  </template>

<script>
import axios from 'axios'
import auth from './auth'
export default {
  name: 'modalVendor',
  components: {
  },
  props: {
    parentData: {
      type: String
    }
  },
  data: function () {
    return {
      vendorinfo: {},
      user: auth.user,
      apiUrl: localStorage.getItem('apiURL')
    }
  },
  methods: {
  },
  mounted: function () {
    axios
      .get(this.apiUrl + auth.user.clientID + '/contracts/' + this.parentData + '/vendors', {
        headers: auth.getAuthHeader()
      })
      .then(response => {
        this.vendorinfo = response.data
        console.log(this.vendorinfo)
      })
  },
  computed: {
    isLoaded: function () {
      if (this.hasOwnProperty('vendorinfo') &&
      this.vendorinfo != null) {
        return true
      }
      return false
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/modalVendor.vue